import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import Slide from '@mui/material/Slide';

function CustomSnackbar({ open, message, onClose, color, duration = 5000 }) {
  let snackbarColor = 'green';

  if (color === 'error') {
    snackbarColor = '#d3252b';
  } else if (color === 'warning') {
    snackbarColor = 'orange';
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      TransitionComponent={Slide}
      transitionDuration={600}
    >
      <SnackbarContent message={message} style={{ backgroundColor: snackbarColor }} />
    </Snackbar>
  );
}

export default CustomSnackbar;
